var _rect, _g, _g2, _g3, _circle, _rect2, _circle2, _rect3, _circle3, _rect4, _circle4, _rect5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisuEmissions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 357,
    viewBox: "0 0 383 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 383,
    height: 357,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 9,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 12H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 39,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 42H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 69,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 72H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 99,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 102H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 129,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 132H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.99988,
    y: 159,
    width: 15,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 162H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.99988,
    y: 189,
    width: 16,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 192H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 219,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 222H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 249,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 252H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 279,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 282H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.48328,
    y: 309,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4833 312H379.517",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.4833,
    width: 100,
    height: 60,
    fill: "#F6AD55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.4833,
    y: 60,
    width: 100,
    height: 16,
    fill: "#FBD38D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.4833,
    y: 76,
    width: 100,
    height: 27,
    fill: "#FEEBC8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.483,
    y: 102,
    width: 100,
    height: 176,
    fill: "#C6F6D5"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 349,
    r: 8,
    fill: "#FEEBC8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 345.5,
    width: 64,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 349,
    r: 8,
    fill: "#FBD38D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 345.5,
    width: 52,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 349,
    r: 8,
    fill: "#F6AD55"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 345.5,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 349,
    r: 8,
    fill: "#C6F6D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 345.5,
    width: 95,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 318,
    fill: "white",
    transform: "translate(2.48328 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 63)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 63)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 123)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 153)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 183)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 213)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 243)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 243)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 273)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 273)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 377.033,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 303)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white",
    transform: "translate(2.48328 303)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4833 8C86.4833 3.58172 90.065 0 94.4833 0H178.483C182.902 0 186.483 3.58172 186.483 8V103H86.4833V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.483 102H334.483V270C334.483 274.418 330.902 278 326.483 278H242.483C238.065 278 234.483 274.418 234.483 270V102Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisuEmissions);
export default __webpack_public_path__ + "static/media/visu_emissions.06b82632cc42927c092bb9710604ef4e.svg";
export { ForwardRef as ReactComponent };